// eslint-disable-next-line no-unused-vars
import React, {
 Suspense, useReducer, useState, useEffect, // eslint-disable-line no-unused-vars
} from 'react';
import PropTypes from 'prop-types';
import {
  ButtonSecondary, // eslint-disable-line no-unused-vars
  IconSuccess, // eslint-disable-line no-unused-vars
  Search, // eslint-disable-line no-unused-vars
} from '@americanexpress/dls-react';
import { AdvFormSearch, ErrorBoundary, Loader } from 'axp-fx-common'; // eslint-disable-line no-unused-vars
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { actionSearchFormProp, defaultFilterData } from './actionsInitData';
import fields from '../../../constants/fields';
import { fetchActionTypes, fetchStatuses } from '../../../utils/apiUtil';

const ActionsHeader = ({ setFilterData, filterData }) => {
  const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));
  const loginData = useSelector((state) => state.getIn([
      'modules',
      'axp-secure-file-express-root',
      'userData',
      'login',
    ])
  );

  const [searchTextValue, setSearchTextValue] = useState('');
  const [advSearch, setAdvSearch] = useState(false);
  const [actionTypeOptions, setActionTypeOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [advFormData, setAdvFormData] = useReducer(
    (val, newVal) => ({ ...val, ...newVal }),
    _.cloneDeep(actionSearchFormProp)
  );

  /* handle filter data change on click of adv search 'Search' */
  const handleAdvFormSearchClick = () => {
    const newFilterData = _.clone(filterData);
    newFilterData[fields.actionType] = advFormData.formFields[0].value;
    newFilterData[fields.reqId] = advFormData.formFields[1].value;
    newFilterData[fields.actionStatus] = advFormData.formFields[2].value;
    setFilterData(newFilterData);
  };

  /* toggle the adv search */
  const toggleAdvFormSearch = () => {
    setAdvSearch(!advSearch);
  };

  /* handle filter data change on click of search icon when adv search is toggled off */
  const handleSearchClick = () => {
    const newFilterData = _.clone(defaultFilterData);
    newFilterData[fields.reqId] = searchTextValue;
    setFilterData(newFilterData);
  };

  /* handle value change for req id search. enter key doesn't perform a search */
  const handleSearchKeyDownChange = (e) => {
    if (e.keyCode !== 13) {
      setSearchTextValue(e.target.value);
    } else if (advSearch && e.keyCode === 13) {
      e.preventDefault();
    }
  };

  /* handle adv search reset and re-assign the suggestion lists back to the form */
  const resetAdvSearchHandlerTriggered = () => {
    const newAdvFormData = _.cloneDeep(actionSearchFormProp);
    const newFormFields = newAdvFormData?.formFields;
    newFormFields[0].suggestionList = actionTypeOptions;
    newFormFields[2].suggestionList = statusOptions;
    newAdvFormData.formFields = newFormFields;
    setAdvFormData(newAdvFormData);
  };

  useEffect(() => {
    const getInitialDataLoad = async () => {
      const newAdvFormData = _.cloneDeep(advFormData);
      const newFormFields = newAdvFormData?.formFields;

      const apiMetaData = {
        fxgApiHost,
      };
      const promiseArray = await Promise.all([
        fetchActionTypes(apiMetaData),
        fetchStatuses(apiMetaData),
      ]);

      // populate the suggestion list for dropdowns
      const actionType = promiseArray[0]?.map((data) => ({
        id: data.requestTypeId,
        name: data.requestTypeName,
        value: data.requestTypeName,
      }));
      const status = promiseArray[1]?.map((data) => ({
        id: data.statusId,
        name: data.statusName,
        value: data.statusName,
      }));

      newFormFields[0].suggestionList = [...actionType];
      newFormFields[2].suggestionList = [...status];

      setActionTypeOptions(actionType);
      setStatusOptions(status);

      newAdvFormData.formFields = newFormFields;
      setAdvFormData(newAdvFormData);
    };
    getInitialDataLoad();
  }, []); // initial load only

  return (
    <>
      <div id="search-container" className="row">
        <div style={{ width: '50%' }}>
          <Search
            id="search-category-search-bar"
            buttonSearch={!advSearch}
            value={searchTextValue}
            onChange={(e) => setSearchTextValue(e.target.value)}
            onSearch={handleSearchClick}
            onKeyDown={handleSearchKeyDownChange}
            placeholder="Search By Request ID"
            labelText="searchBar"
          />
        </div>
        <div style={{ marginTop: '5px' }}>
          <ButtonSecondary
            id="advSearchBtn"
            aria-label="Advanced Search"
            className="margin-responsive-l"
            onClick={toggleAdvFormSearch}
            icon={<IconSuccess filled={advSearch} />}
            size="md"
          >
            Advanced Search
          </ButtonSecondary>
        </div>
      </div>
      {advSearch && (
        <div
          id="advFormContainer"
          //  css={searchEntityStyles['.advFormContainer']}
          className="dls-gray-02-bg"
        >
          <ErrorBoundary>
            <Suspense fallback={<Loader showLoader={true} />}>
              <AdvFormSearch
                advFormData={advFormData}
                setAdvFormData={setAdvFormData}
                handleAdvFormSearchClick={handleAdvFormSearchClick}
                toggleAdvFormSearch={toggleAdvFormSearch}
                intlFormData={_.cloneDeep(actionSearchFormProp)}
                acsMgmt={fxgApiHost}
                loginData={loginData}
                resetHandlerTriggered={resetAdvSearchHandlerTriggered}
                retainValues={true}
              />
            </Suspense>
          </ErrorBoundary>
        </div>
      )}
    </>
  );
};

ActionsHeader.propTypes = {
  setFilterData: PropTypes.func.isRequired,
  filterData: PropTypes.string.isRequired,
};

export default ActionsHeader;
